import { createContext, useContext, Children } from 'react';
import { Modal, message } from 'antd';

// 1. 创建上下文
const ModalContext = createContext<{
    confirm: (opts: Parameters<typeof Modal.confirm>[0]) => void;
}>({
    confirm: () => {},
});

// 2. 封装 Confirm 组件（提供者）
export default ({ children }) => {
    const [messageApi, contextHolder] = message.useMessage();
    // 封装 confirm 方法
    const $success = (content) => {
        return messageApi.open({
            type: 'success',
            content,
        });
    };

    const error = (content) => {
        return messageApi.open({
            type: 'error',
            content,
        });
    };

    const warning = (content) => {
        return messageApi.open({
            type: 'warning',
            content,
        });
    };

    const loading = (content) => {
        messageApi.open({
            type: 'loading',
            content,
            duration: 0,
        });

        return messageApi.destroy;
    };

    return (
        <ModalContext.Provider
            value={{
                success: $success,
                error,
                warning,
                loadingMissage: loading,
            }}
        >
            {Children.map(children, (child) => {
                return child;
            })}
            {contextHolder}
        </ModalContext.Provider>
    );
};

// 3. 自定义 Hook，方便外部使用
export const useMessage = () => useContext(ModalContext);
